// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.header-home {
    font-size: 50px;
    text-align: center;
}

.button-home {
    margin-top: 60px;
    margin-bottom: 10px;
}

.button-home {
  background-color: #fff000;
  border-radius: 12px;
  color: #000;
  cursor: pointer;
  font-weight: bold;
  padding: 10px 15px;
  text-align: center;
  transition: 200ms;
  width: 150px;
  box-sizing: border-box;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-home:not(:disabled):hover,
.button-home:not(:disabled):focus {
  outline: 0;
  background: #f4e603;
  box-shadow: 0 0 0 2px rgba(0,0,0,.2), 0 3px 8px 0 rgba(0,0,0,.15);
}

.button-home:disabled {
  filter: saturate(0.2) opacity(0.5);
  -webkit-filter: saturate(0.2) opacity(0.5);
  cursor: not-allowed;
}

.mini-carta-ejemplo {
    border: 1px solid #ccc;
    border-radius: 10px;
    width: 400px;
    height: 600px;
}

.text-home {
    font-size: 20px;
    text-align: justify;
    margin-top: 20px;
    width: 60%;
}

@media screen and (max-width: 1000px) {
    .text-home {
      width: 80%;
    }

    .mini-carta-ejemplo {
      width: 75%;
    }
}`, "",{"version":3,"sources":["webpack://./src/style/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;AACJ","sourcesContent":[".home {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.header-home {\r\n    font-size: 50px;\r\n    text-align: center;\r\n}\r\n\r\n.button-home {\r\n    margin-top: 60px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.button-home {\r\n  background-color: #fff000;\r\n  border-radius: 12px;\r\n  color: #000;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  padding: 10px 15px;\r\n  text-align: center;\r\n  transition: 200ms;\r\n  width: 150px;\r\n  box-sizing: border-box;\r\n  border: 0;\r\n  font-size: 16px;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n}\r\n\r\n.button-home:not(:disabled):hover,\r\n.button-home:not(:disabled):focus {\r\n  outline: 0;\r\n  background: #f4e603;\r\n  box-shadow: 0 0 0 2px rgba(0,0,0,.2), 0 3px 8px 0 rgba(0,0,0,.15);\r\n}\r\n\r\n.button-home:disabled {\r\n  filter: saturate(0.2) opacity(0.5);\r\n  -webkit-filter: saturate(0.2) opacity(0.5);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.mini-carta-ejemplo {\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px;\r\n    width: 400px;\r\n    height: 600px;\r\n}\r\n\r\n.text-home {\r\n    font-size: 20px;\r\n    text-align: justify;\r\n    margin-top: 20px;\r\n    width: 60%;\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n    .text-home {\r\n      width: 80%;\r\n    }\r\n\r\n    .mini-carta-ejemplo {\r\n      width: 75%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
